import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, limit, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { dbWeb } from "../firebaseConfig";
import { getExcerptFromRaw, getTitleFromRaw } from "../utils/tazkirahUtils";

export default function LatestTazkirah() {
  const [article, setArticle] = useState(null);

  useEffect(() => {
    const latestQuery = query(
      collection(dbWeb, "tazkirah"),
      where("status", "==", "published"),
      orderBy("publishedAt", "desc"),
      limit(1)
    );

    const unsubscribe = onSnapshot(
      latestQuery,
      (snapshot) => {
        const document = snapshot.docs[0];
        setArticle(document ? { id: document.id, ...document.data() } : null);
      },
      (error) => {
        console.error("Gagal membaca tazkirah terkini:", error);
        setArticle(null);
      }
    );

    return () => unsubscribe?.();
  }, []);

  if (!article) return null;

  const title = article.title || getTitleFromRaw(article.raw);
  const excerpt = getExcerptFromRaw(article.raw);

  return (
    <section className="latest-tazkirah-section" aria-labelledby="latest-tazkirah-title">
      <div className="home-reading-label">TAZKIRAH</div>
      <article className="latest-tazkirah-card">
        <div className="latest-tazkirah-copy">
          <h3 id="latest-tazkirah-title">{title}</h3>
          {excerpt && <p>{excerpt}</p>}
        </div>
        <Link to={`/tazkirah/${article.id}`}>Baca lagi</Link>
      </article>
    </section>
  );
}
